import { Spinner } from './shadcn/Spinner';

export function PageSpinner() {
  return (
    <div className="flex items-center justify-center h-full">
      <Spinner className="size-8" />
    </div>
  );
}
